import { packagesStateName } from "./constants";

const getPackagesState = (store) => store[packagesStateName];
export const getUserPackages = (s) => getPackagesState(s).packages;
